
import moment from 'moment';
import { rutValidator } from 'vue-dni';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import messages from '@/i18n';


Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule],
    message: messages.es.validation[rule],
  });
});
extend('minDate', {
  validate(newDate, { oldDate }) {
    return moment.isDate(newDate) && (moment(newDate) >= moment(oldDate).add(1, 'h'));
  },
  params: ['oldDate'],
  message: 'La nueva {_field_} debe ser posterior a la fecha límite actual',
});
extend('rut', {
  validate: rutValidator,
  message: 'El {_field_} no es válido',
});


export default ({ Vue }) => {
  Vue.component('ValidationObserver', ValidationObserver);
  Vue.component('ValidationProvider', ValidationProvider);
};



// WEBPACK FOOTER //
// ./src/plugins/vee-validate.js